import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AreaAccessService {
  private cache = {
    areaAccess: null
  };

  constructor(private readonly httpService: HttpService) { }

  public getAreaAccess(area: string): Observable<any> {
    if (!this.cache.areaAccess) {
      this.cache.areaAccess = {}
    }

    if (!this.cache.areaAccess[area]) {
      this.cache.areaAccess[area] = this.httpService.get<any>(`area-accesses/${area}`).pipe(
        shareReplay({ bufferSize: 1, refCount: true }),
        catchError(err => {
          this.cache.areaAccess[area] = {};
          throw err;
        })
      );
    }

    return this.cache.areaAccess[area];
  }

  public checkForPermission(path: string): Observable<boolean> {
    const [firstLevel, ...pathArray] = path.split('.');

    return this.getAreaAccess(firstLevel).pipe(
      map(data => {
        let notFound = false;
        const hasPermission = !pathArray?.length || pathArray.reduce((object, propertyName) => {
          if (notFound) {
            return true;
          }

          const child = object[propertyName];
          if (child === undefined) {
            notFound = true;
            console.error(`Permission '${path}' does not exist`);
            return true;
          }

          return child;
        }, data);

        return !!hasPermission;
      })
    );
  }
}